import LibraryElementEnum from 'client/enums/LibraryElementEnum'
import React from 'react'
import { libraryItems } from 'src/editor/layout/sidebar/library/library-items'
import { SettingsMenuItem } from '../../components/settings-menu-buttons/settings-menu-item'

interface WebsiteHeaderLibraryElementProps {
  libraryElement: LibraryElementEnum
}

export const WebsiteHeaderLibraryElement = ({
  libraryElement,
}: WebsiteHeaderLibraryElementProps) => {
  const item = libraryItems[libraryElement]
  return (
    <SettingsMenuItem
      title={item?.title}
      icon={() => (
        <>
          {'className' in item && <span className={item.className} />}
          {'iconRenderer' in item && item.iconRenderer?.()}
        </>
      )}
    />
  )
}
